import { render } from "./navigation-footer.vue?vue&type=template&id=a43ddd7c&scoped=true&ts=true"
import script from "./navigation-footer.vue?vue&type=script&lang=ts"
export * from "./navigation-footer.vue?vue&type=script&lang=ts"

import "./navigation-footer.vue?vue&type=style&index=0&id=a43ddd7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43ddd7c"]])

export default __exports__